import { useFont } from '@octane/spark'
import styled from 'styled-components'

const LabelStyle = styled.div`
    display: flex;
    margin-left: 10px;
    ${() => useFont('c16', { weight: '400' })};
`

export default LabelStyle
